import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

export default (
    <Router>
        <Routes>
        </Routes>
    </Router>
);
